<script>
    import { onMount, createEventDispatcher } from 'svelte'


    import axios from 'axios'
    import AdminLayout from '../../layouts/AdminLayout.svelte'
    import Sidepanel from '../../components/Sidepanel/Sidepanel.svelte'
    import AlertsSideContent from './AlertsSideContent.svelte'
    import RulesList, { API as RulesListAPI } from './RulesList/RulesList.svelte'
    import { background } from '../../components/Notifications/AppNotifications.svelte'
    import FadeinFX from '../../components/FX/FadeinFx.svelte'
    // import userStore from '../../stores/user'

    export let id

    const dispatch = createEventDispatcher ();
    
    let screenReady     = false,
        clients         = {},
        workers         = {},
        model           = null,
        searchQuery     = ''

    
    const onSearch = (event) => {
        // console.log ('onSearch', event.detail)
        searchQuery = event.detail
    }

    const fetchModel = (sectorId) => {
        background (true)
        axios.request ({
            method: 'get',
            url: '/api/alerts/rules/' + sectorId
        }).then (results => {
            clients = { ...results.data.clients }
            workers = { ...results.data.users }
            model = results.data.rules.map (it => {
                const progdata = JSON.parse (it.payload)
                const operators = progdata && progdata.operators ? progdata.operators.split(',').map (it => workers[it] || null).filter(it => it !== null) : []
                return {
                    ...it,
                    ...{
                        client: clients[it.client],
                        oprts: operators
                    }
                }
            }).sort ((a, b) => {
                return a.client.name > b.client.name ? 1 : -1
            })
            background (false)
            screenReady = true
        }).catch (e => {
            dispatch ('app-event', { id: 'app-error', error: e });
        })
    }

    const onRuleCreate = (event) => {
        // console.log ('onRuleCreate')
        RulesListAPI.create ();
    }

    const onListChanged = () => {
        fetchModel (id)
    }

    $: fetchModel (id);
</script>


<Sidepanel>
    <AlertsSideContent on:search={onSearch} on:create={onRuleCreate} />
</Sidepanel>
<AdminLayout classes="sidepanel">
    <div class="page-pad avoid-selection">
        {#if screenReady}
            <FadeinFX delay={400} delayOut={0}>
                <RulesList {model} {clients} {workers} {searchQuery} on:list-changed={onListChanged} />
            </FadeinFX>
        {/if}
    </div>
</AdminLayout>


<style>
    
</style>